module.exports = __webpack_public_path__ + "media/site_templates/www.pavingcontractors.com.au/images/splash-5c63242ea3a2b1bb7b59f003f03685c1.jpg";